/** @jsx jsx */
import React, {
  Fragment as _,
  useState,
  useRef,
  useLayoutEffect,
  useEffect,
  Component,
} from 'react';
import { css, jsx } from '@emotion/core';

const A = ({ href, title, target, attributes, children }) => {
  useEffect(() => {
    const a = attributes.ref.current;
    const localColor = Array.from(a.querySelectorAll('span')).find(
      (span: any) => span.style.color
    ) as any;

    if (localColor) {
      a.style.textDecorationColor = localColor.style.color;
    }
  });

  return (
    <a
      {...attributes}
      href={href}
      title={title}
      target={target}
      style={
        {
          // color: 'inherit',
          // cursor: 'pointer'
        }
      }
      onMouseEnter={
        window.dev()
          ? ({ currentTarget }) => {
              window['CURRENT_LINK_WITH_FOCUS'] = {
                text: currentTarget.innerText,
                href,
              };
            }
          : null
      }
      onMouseOut={
        window.dev() ? () => (window['CURRENT_LINK_WITH_FOCUS'] = null) : null
      }
    >
      {children}
    </a>
  );
};

const renderInline = (props, editor, next) => {
  const { attributes, children, node } = props;

  switch (node.type) {
    case 'link': {
      const { data } = node;
      const href = data.get('href');
      const title = data.get('title');
      const target = data.get('target');

      return (
        <A href={href} title={title} target={target} attributes={attributes}>
          {children}
        </A>
      );
    }

    default:
      return next();
  }
};

export default renderInline;
